<template>
    <div class="app-container">
        
        <div class="app-left">
            <div class="app-left-content">
                <router-view />
            </div>
        </div>

    </div>
</template>

<style src="../styles/mainLayout.css"></style>